export enum TickerCellBlock {
  Root = 'TickerCell',
}
